import api from './base-api';
import { TrackViewDto } from '@sportspredict/shared';

const viewsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		trackView: builder.mutation<void, TrackViewDto>({
			query: (body) => ({
				url: '/views',
				method: 'POST',
				body,
			}),
		}),
	}),
	overrideExisting: false,
});

export default viewsApi;

export const { useTrackViewMutation } = viewsApi;
